import copyLink from '../../assets/socials/copyLink.png';
import discord from '../../assets/socials/discord.png';
import facebook from '../../assets/socials/facebook.png';
import instagram from '../../assets/socials/instagram.png';
import messages from '../../assets/socials/messages.png';
import reddit from '../../assets/socials/reddit.png';
import snapchat from '../../assets/socials/snapchat.png';
import stories from '../../assets/socials/stories.png';
import telegram from '../../assets/socials/telegram.png';
import twitter from '../../assets/socials/twitter.png';
import whatsApp from '../../assets/socials/whatsApp.png';

export const sharingSocials = [
    {
        image: whatsApp,
        label: 'WhatsApp',
    },
    {
        image: twitter,
        label: 'Twitter',
    },
    {
        image: instagram,
        label: 'Instagram',
    },
    {
        image: messages,
        label: 'Messages',
    },
    {
        image: facebook,
        label: 'Facebook',
    },
    {
        image: telegram,
        label: 'Telegram',
    },
  
   
];
 // {
    //     image: stories,
    //     label: 'Stories',
    // },



    // {
    //     image: discord,
    //     label: 'Discord',
    // },
    // {
    //     image: snapchat,
    //     label: 'Snapchat',
    // },
    // {
    //     image: reddit,
    //     label: 'Reddit',
    // },